import { renderPage } from "renderPage"
import { AccountReviewIndexPage } from "./Page"

renderPage({ component: AccountReviewIndexPage })
